const purchasingDataset = [
  {
    date: new Date("2020-01-01"),
    gross: 10000,
    nett: 25000,
    apv: 3000,
    lpt: 7
  },
  {
    date: new Date("2020-03-01"),
    gross: 10000,
    nett: 27000,
    apv: 3000,
    lpt: 8
  },
  {
    date: new Date("2020-03-02"),
    gross: 10000,
    nett: 34000,
    apv: 3000,
    lpt: 7
  },
  {
    date: new Date("2020-03-04"),
    gross: 10000,
    nett: 28000,
    apv: 3000,
    lpt: 8
  },
  {
    date: new Date("2020-03-05"),
    gross: 10000,
    nett: 26500,
    apv: 3000,
    lpt: 8
  },
  {
    date: new Date("2020-03-06"),
    gross: 10000,
    nett: 27000,
    apv: 3000,
    lpt: 8
  },
  {
    date: new Date("2020-03-07"),
    gross: 10000,
    nett: 12000,
    apv: 3000,
    lpt: 8
  },
  {
    date: new Date("2020-03-08"),
    gross: 10000,
    nett: 34500,
    apv: 3000,
    lpt: 8
  },
  {
    date: new Date("2020-03-09"),
    gross: 10000,
    nett: 32000,
    apv: 3000,
    lpt: 8
  },
  {
    date: new Date("2020-03-10"),
    gross: 10000,
    nett: 29000,
    apv: 3000,
    lpt: 8
  },
  {
    date: new Date("2020-03-11"),
    gross: 10000,
    nett: 26000,
    apv: 3000,
    lpt: 8
  },
  {
    date: new Date("2020-03-12"),
    gross: 10000,
    nett: 25000,
    apv: 3000,
    lpt: 8
  },
  {
    date: new Date("2020-03-13"),
    gross: 10000,
    nett: 21000,
    apv: 3000,
    lpt: 8
  },
  {
    date: new Date("2020-02-01"),
    gross: 15000,
    nett: 27000,
    apv: 3000,
    lpt: 8
  },
  {
    date: new Date("2020-03-14"),
    gross: 10000,
    nett: 34000,
    apv: 3000,
    lpt: 8
  },
  {
    date: new Date("2020-03-15"),
    gross: 10000,
    nett: 11000,
    apv: 3000,
    lpt: 8
  },
  {
    date: new Date("2020-03-03"),
    gross: 15000,
    nett: 18000,
    apv: 3000,
    lpt: 7
  },
  {
    date: new Date("2019-12-01"),
    gross: 35000,
    nett: 29000,
    apv: 3000,
    lpt: 8
  },
  {
    date: new Date("2019-11-01"),
    gross: 40000,
    nett: 45000,
    apv: 3000,
    lpt: 8
  },
  {
    date: new Date("2019-10-01"),
    gross: 15000,
    nett: 38000,
    apv: 3000,
    lpt: 7
  },
  {
    date: new Date("2019-09-01"),
    gross: 15000,
    nett: 45000,
    apv: 3000,
    lpt: 7
  },
  {
    date: new Date("2019-08-01"),
    gross: 15000,
    nett: 10000,
    apv: 3000,
    lpt: 6
  },
  {
    date: new Date("2020-02-27"),
    gross: 15000,
    nett: 26000,
    apv: 3000,
    lpt: 7
  },
  {
    date: new Date("2020-02-26"),
    gross: 15000,
    nett: 17000,
    apv: 3000,
    lpt: 8
  },
  {
    date: new Date("2020-02-25"),
    gross: 15000,
    nett: 15500,
    apv: 3000,
    lpt: 7
  },
  {
    date: new Date("2020-02-24"),
    gross: 15000,
    nett: 29000,
    apv: 3000,
    lpt: 8
  },
  {
    date: new Date("2020-02-23"),
    gross: 15000,
    nett: 31000,
    apv: 3000,
    lpt: 7
  },
  {
    date: new Date("2020-02-20"),
    gross: 15000,
    nett: 27000,
    apv: 3000,
    lpt: 1000
  },
  {
    date: new Date("2020-02-13"),
    gross: 15000,
    nett: 29000,
    apv: 3000,
    lpt: 1000
  },
  {
    date: new Date("2020-02-07"),
    gross: 15000,
    nett: 29000,
    apv: 3000,
    lpt: 7
  },
  {
    date: new Date("2020-02-01"),
    gross: 15000,
    nett: 39000,
    apv: 3000,
    lpt: 6
  },
  {
    date: new Date("2020-02-29"),
    gross: 15000,
    nett: 10000,
    apv: 3000,
    lpt: 1000
  },
  {
    date: new Date("2020-03-29"),
    gross: 15000,
    nett: 10000,
    apv: 3000,
    lpt: 1000
  },
  {
    date: new Date("2020-02-22"),
    gross: 15000,
    nett: 10000,
    apv: 3000,
    lpt: 8
  },
  {
    date: new Date("2020-02-21"),
    gross: 15000,
    nett: 10000,
    apv: 3000,
    lpt: 7
  },
  {
    date: new Date("2020-02-28"),
    gross: 15000,
    nett: 10000,
    apv: 3000,
    lpt: 6
  },
];

const purchasingFields = [
  {
    label: "nett",
    backgroundColor: "#37B04C"
  },
  {
    label: "gross",
    backgroundColor: "#289E45"
  },
  {
    label: "apv",
    backgroundColor: "#7AE28C"
  },
  {
    label: "lpt",
    backgroundColor: "#707070"
  }
];

export { purchasingDataset, purchasingFields };
